const firefoxStoreLink = 'https://addons.mozilla.org/en-US/firefox/addon/phishcloud/';

export default firefoxStoreLink;
